import React from 'react';
import { AnnoNode, Annotation } from '../../domain/domain';
import AnnotationTreeItem from './AnnotationTreeItem';
import AnnoNodeTitle from './AnnoNodeTitle';

type Props = {
    parent: Annotation,
    items: AnnoNode[],
    onNodeLabelClicked: (node: AnnoNode) => void,
    onContextMenu: (event: any, tree: AnnoNode) => void
}

const AnnotationTreeItemComponent: React.FC<Props> = ({ parent, items, onNodeLabelClicked, onContextMenu }) => {
  const renderTree = (nodes: AnnoNode[]) =>
    nodes.map((node: AnnoNode) => (
      node && node.annoId &&
        <AnnotationTreeItem
          key={node.annoId}
          nodeId={node.annoId.toString()}
          label={
            <AnnoNodeTitle nodeId={node.annoId}/>
          }
          onLabelClick={() => {
            onNodeLabelClicked(node)
          }}
          onContextMenu={(event: React.MouseEvent) => onContextMenu(event, node)}
        >
          {Array.isArray(node.children) ? renderTree(node.children) : null}
        </AnnotationTreeItem>
    ));

  return (
    <AnnotationTreeItem
      key={0}
      nodeId="0"
      label={
        <AnnoNodeTitle nodeId={0}/>
      }
      onLabelClick={() => {
        onNodeLabelClicked(parent)
      }}
      onContextMenu={(event: React.MouseEvent) => onContextMenu(event, parent)}
    >
      {items && renderTree(items)}
    </AnnotationTreeItem>
  )
}

export default AnnotationTreeItemComponent;
